import { Providers } from 'providers';
import React, { FC } from 'react';
import { Content } from './Content';
import { LazyProfileDrawerProps } from './types';

const LazyProfileDrawer: FC<LazyProfileDrawerProps> = ({ withToastProvider = true, ...rest }) => (
  <Providers withToastProvider={withToastProvider}>
    <Content {...rest} />
  </Providers>
);

export default LazyProfileDrawer;
